import { render, staticRenderFns } from "./RollObjectDrawer.vue?vue&type=template&id=db5d7678&"
import script from "./RollObjectDrawer.vue?vue&type=script&lang=ts&"
export * from "./RollObjectDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports